import React from 'react';

export default function LocationContact({location}) {
    return (
        <div className={"font-bold"}>
            You are matched with our <a href={location.site} className={"whitespace-nowrap !text-brand-blue !decoration-brand-blue hover:!decoration-transparent"}>{location.location_name}</a> location.
            Got questions? Give us a call at <a href={`tel:${location.phone}`} className={"whitespace-nowrap !text-brand-blue !decoration-brand-blue hover:!decoration-transparent"}>{location.phone}</a> and we can help you out!
        </div>
    )
}